import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const BILL_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Bill>[] = [
    { name: "subtotal", label: "Total" },
    { name: "amount_due", label: "Amount Due" },
    { name: "date_issued", label: "Issued" },
    { name: "terms", label: "Terms" },
    { name: "payment_status", label: "Paid Status" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const BILL_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Bill>[] = [
    { name: "id", label: "ID" },
    { name: "status_label", label: "Status" },
    { name: "state_label", label: "State" },
    { name: "subtotal", label: "Total" },
    { name: "amount_due", label: "Amount Due" },
    { name: "vendor_name", label: "Vendor" },
    { name: "vendor_invoice_id", label: "Vendor Invoice ID" },
    { name: "date_due", label: "Due Date" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "last_received_at", label: "Received" },
    { name: "last_paid_at", label: "Paid" },
    { name: "last_voided_at", label: "Voided" },
]
